<main>
    <!-- HEADER -->
    <mat-card class="m-auto padding12 home-card boxshadowgrey">
        <div>
            <button mat-icon-button color="primary" class="back-button" routerLink="/machineState">
                <mat-icon>arrow_back</mat-icon>
            </button>
        </div>
        <div class="content">
        <mat-card-title-group class="home-card" id="title">
            <div class="header">
                <mat-card-title> {{"MASCHINESTATE.PRESSURE.HEADER_MULTI" | translate}}</mat-card-title>

                
            </div>
        </mat-card-title-group>
        <!-- CONTENT -->
        <mat-card-content>
            <div class="home-card" id="content">
                <ng-container *ngIf="this.gatewayConnectionService.gatewayConnected == false"
                    >{{"MESSAGES.CONN_WAITING" | translate}}</ng-container
                >

                <ng-container *ngIf="this.gatewayConnectionService.gatewayConnected == true">
                    <div class="stack-wrapper">
                        <div class="background stack" id="wrapper">
                            <img
                                class="cabine-background"
                                id="image"
                                src="../../../../../../assets/images/machine/multi/360G_SW_aus.svg"
                                alt=""
                                (load)="this.imgLoaded = true"
                            />
                        </div>

                        <ng-container *ngIf="this.imgLoaded == true">

                            <!-- Position Values-->
                            <div class="value-block amp stack" id="position">
                                <div class="value-block-title">
                                    <mat-icon svgIcon="boomAngleIcon"></mat-icon>
                                    {{"MASCHINESTATE.POSITION.MENU" | translate}}</div>
                                <div class="scrollable">
                                    <ng-container *ngFor="let datapoint of this.equipmentPressureDataset.dataPoints">
                                        <ng-container *ngIf="datapoint.position == this.positionEnum.Position">
                                            <div class="datapoint borderred" id="wrapper">
                                                <div class="datapoint bordergreen" id="name">{{ datapoint.generalName | translate}}:</div>
                                                <div class="datapoint borderblue" id="value">{{ datapoint.value != 100794368 ? datapoint.value : '-' }} {{ datapoint.unit }}</div>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </div>


                            <!-- Pressure Values-->
                            <div class="value-block amp stack" id="pressure">
                                <div class="value-block-title">
                                    <mat-icon svgIcon="pressure"></mat-icon>
                                    {{"MASCHINESTATE.PRESSURE.MENU" | translate}}</div>
                                <div class="scrollable">
                                    <ng-container *ngFor="let datapoint of this.equipmentPressureDataset.dataPoints">
                                        <ng-container *ngIf="datapoint.position == this.positionEnum.Pressure">
                                            <div class="datapoint borderred" id="wrapper">
                                                <div class="datapoint bordergreen" id="name">{{ datapoint.generalName |translate }}:</div>
                                                <div class="datapoint borderblue" id="value">{{ datapoint.value != 100794368 ? datapoint.value : '-' }} {{ datapoint.unit }}</div>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </div>
                                
                            </div>

                        </ng-container>
                    </div>
                </ng-container>
            </div>
        </mat-card-content>
    </div>
    </mat-card>
</main>
